import { render, staticRenderFns } from "./InfoSection.vue?vue&type=template&id=b30c2e66&scoped=true"
import script from "./InfoSection.vue?vue&type=script&lang=js"
export * from "./InfoSection.vue?vue&type=script&lang=js"
import style0 from "./InfoSection.vue?vue&type=style&index=0&id=b30c2e66&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b30c2e66",
  null
  
)

export default component.exports